import * as React from 'react';

import { mergeClassNames } from '@/lib/utils';

const ChevronDown = ({
  className,
  rotate = 0,
  ...props
}: React.ComponentProps<'svg'> & {
  rotate?: number;
}) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={mergeClassNames('w-[18px] h-[18px]', className)}
    style={{ rotate: `${rotate}deg` }}
    {...props}
  >
    <path
      d="M3.52827 5.52851C3.78862 5.26816 4.21073 5.26816 4.47108 5.52851L7.99967 9.05711L11.5283 5.52851C11.7886 5.26816 12.2107 5.26816 12.4711 5.52851C12.7314 5.78886 12.7314 6.21097 12.4711 6.47132L8.47108 10.4713C8.21073 10.7317 7.78862 10.7317 7.52827 10.4713L3.52827 6.47132C3.26792 6.21097 3.26792 5.78886 3.52827 5.52851Z"
      fill="currentColor"
    />
  </svg>
);

export default ChevronDown;
